import { Link } from "react-router-dom";

export default function CheckoutCancel() {
  return (
    <div data-testid="checkout-cancel" className="max-w-2xl mx-auto px-6 py-32 text-center">
      <p className="smallcaps mb-4">Cancelled</p>
      <h1 className="font-display text-5xl text-[#212121] mb-4">Checkout cancelled.</h1>
      <p className="text-[#757575] mb-10">Your cart is still saved. Come back when you're ready.</p>
      <Link to="/shop" className="btn-primary">Back to Shop</Link>
    </div>
  );
}
